(function () {
  "use strict";

  const REPLACEMENTS = new Map([
    ["OR", "SAU"],
    ["Orders", "Comenzi"],
  ]);
  const observedHosts = new WeakSet();

  function isRomanianLocale() {
    const lang = String(document.documentElement.lang || "").toLowerCase();
    return lang.startsWith("ro");
  }

  function replaceKnownText(root) {
    if (!(root instanceof Node)) {
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();

    while (textNode) {
      const original = String(textNode.nodeValue || "");
      const trimmed = original.trim();

      if (REPLACEMENTS.has(trimmed)) {
        textNode.nodeValue = original.replace(trimmed, REPLACEMENTS.get(trimmed));
      }

      textNode = walker.nextNode();
    }
  }

  function bindShadowLocalization(host) {
    if (!(host instanceof HTMLElement)) {
      return;
    }

    const root = host.shadowRoot;

    if (!(root instanceof ShadowRoot)) {
      return;
    }

    if (host.dataset.qkAccountLocaleBound === "1") {
      replaceKnownText(root);
      return true;
    }

    host.dataset.qkAccountLocaleBound = "1";

    const apply = function () {
      replaceKnownText(root);
    };

    apply();

    const observer = new MutationObserver(apply);
    observer.observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
    });

    return true;
  }

  function watchHost(host) {
    if (!(host instanceof HTMLElement)) {
      return;
    }

    if (observedHosts.has(host)) {
      bindShadowLocalization(host);
      return;
    }

    observedHosts.add(host);

    let attempts = 0;

    const ensureBinding = function () {
      const bound = bindShadowLocalization(host);

      if (bound) {
        return;
      }

      attempts += 1;

      if (attempts < 120) {
        window.setTimeout(ensureBinding, 50);
      }
    };

    ensureBinding();
  }

  function watchNewHosts() {
    const root = document.documentElement;

    if (!(root instanceof HTMLElement)) {
      return;
    }

    const observer = new MutationObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.addedNodes.forEach(function (addedNode) {
          if (!(addedNode instanceof Element)) {
            return;
          }

          if (addedNode.matches("shopify-account")) {
            watchHost(addedNode);
          }

          addedNode.querySelectorAll("shopify-account").forEach(function (nestedHost) {
            watchHost(nestedHost);
          });
        });
      });
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    if (!isRomanianLocale()) {
      return;
    }

    document.querySelectorAll("shopify-account").forEach(function (host) {
      watchHost(host);
    });

    watchNewHosts();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
